import React, { useState } from "react";
import "./ExpenseForm.css";

const START_YEAR = 2021;

function ExpenseForm(props) {
  const [enteredTitle, setEnteredTitle] = useState("");
  const [enteredAmount, setEnteredAmount] = useState("");
  const [enteredDate, setEnteredDate] = useState("");
  //   const [userInput, setUserInput] = useState({
  //     enteredTitle: "",
  //     enteredAmount: "",
  //     enteredDate: "",
  //   });

  function titleChangeHandler(event) {
    setEnteredTitle(event.target.value);
    // setUserInput({
    //     ...userInput,
    //     enteredTitle: event.target.value
    // });
    // setUserInput((prevState) => {
    //   return { ...prevState, enteredTitle: event.target.value };
    // });
  }

  function amountChangeHandler(event) {
    setEnteredAmount(event.target.value);
    // setUserInput({
    //   ...userInput,
    //   enteredAmount: event.target.value,
    // });
  }

  function dateChangeHandler(event) {
    setEnteredDate(event.target.value);
    // setUserInput({
    //   ...userInput,
    //   enteredDate: event.target.value,
    // });
  }

  function submitHandlder(event) {
    event.preventDefault();

    const expenseData = {
      title: enteredTitle,
      amount: +enteredAmount,
      date: new Date(enteredDate),
    };

    props.onSaveExpenseData(expenseData);
    setEnteredTitle("");
    setEnteredAmount("");
    setEnteredDate("");
  }

  const currentYear = new Date().getFullYear();

  return (
    <form onSubmit={submitHandlder} cy-data-selector="new-expense-form">
      <div className="new-expense__controls">
        <div className="new-expense__control">
          <label aria-label="title">Title</label>
          <input
            type="text"
            cy-data-selector="new-expense-title"
            onChange={titleChangeHandler}
            value={enteredTitle}
          />
        </div>
        <div className="new-expense__control">
          <label aria-label="amount">Amount</label>
          <input
            type="number"
            min="0.01"
            step="0.01"
            cy-data-selector="new-expense-amount"
            onChange={amountChangeHandler}
            value={enteredAmount}
          />
        </div>
        <div className="new-expense__control">
          <label aria-label="date">Date</label>
          <input
            type="date"
            min={`${START_YEAR}-01-01`}
            max={`${currentYear}-12-31`}
            cy-data-selector="new-expense-date"
            onChange={dateChangeHandler}
            value={enteredDate}
          />
        </div>
      </div>
      <div className="new-expense__actions">
        <button
          type="button"
          cy-data-selector="cancel"
          onClick={props.onCancel}
        >
          Cancel
        </button>
        <button type="submit" cy-data-selector="add-expense">
          Add expense
        </button>
      </div>
    </form>
  );
}

export default ExpenseForm;
